import { createSlice } from "@reduxjs/toolkit"

const initialState : Record<string, any> = {}

const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setGlobalData: (state, action) => {
      state = action.payload
    },
    initGlobalData: (state, ) => {
      state = {}
    }
  }
})

export const {setGlobalData, initGlobalData} = globalSlice.actions

export default globalSlice.reducer